import { addressValidation, AddressValidationDeps } from 'data/schema'

export interface Values {
  firstName: string
  lastName: string
  company: string
  countryCode: string
  regionCode: string
  street: string
  street2: string
  city: string
  postalCode: string
  phoneNumber: string
}

export const schema = {
  firstName: '',
  lastName: '',
  company: '',
  countryCode: '',
  regionCode: '',
  street: '',
  street2: '',
  city: '',
  postalCode: '',
  phoneNumber: ''
}

export const validation = (deps: AddressValidationDeps) => {
  return addressValidation(deps)
}
